import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Explorial_Logo.svg")